const paths = {
  listContact: '/contact/list'
};

export default paths;
